<!--SKU编辑  -->
<template>
	<div>
		<el-dialog title="组织部门信息" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="600px" :before-close="cancle">
			<div class="form-box">

				<el-form label-position="left" :inline="true" size="small" :model="ruleForm" :rules="rules"
					ref="ruleForm">
					<div class="form-text">上级部门：{{currentFrom.currentName}}</div>
					<el-divider></el-divider>

					<el-form-item label="部门全称" prop="groupName" label-width="100px">
						<el-input class="ml10 width100" v-model="ruleForm.groupName" maxlength="25"></el-input>
					</el-form-item>
					<div class="flex flex-between">
						<el-form-item label="部门简称" prop="groupShortName" label-width="100px">
							<el-input class="ml10 w190" v-model="ruleForm.groupShortName" maxlength="10"></el-input>
						</el-form-item>
						<el-form-item label="部门编码" prop="groupCode" label-width="100px">
							<el-input class=" w190" v-model="ruleForm.groupCode" maxlength="5"></el-input>
						</el-form-item>
					</div>
					<el-form-item class="flex" label="SAP利润中心" prop="profitCenterCode" label-width="110px">
						<el-input class="w190" v-model="ruleForm.profitCenterCode" maxlength="10"></el-input>
					</el-form-item>
					<el-form-item prop="groupType" label-width="100px">
						<el-checkbox class="ml10" v-model="ruleForm.groupType">是否业务部门</el-checkbox>
					</el-form-item>
					<el-divider class="line"></el-divider>
					<el-form-item class="block" label="价格方案" prop="pricePlanName">
						<div class="flex">
							<el-input class="w440" v-model="ruleForm.pricePlanName" readonly></el-input>
							<el-button type="primary" size="small" class="ml20" @click="showPriceScheme">配置价格方案
							</el-button>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<priceScheme ref="priceScheme" @getPriceList="getPriceList" v-if="priceSchemeDialog"></priceScheme>
	</div>
</template>

<script>
	import priceScheme from './price-scheme.vue';
	export default {
		components: {
			priceScheme
		},
		data() {
			return {
				dialogVisible: false,
				priceSchemeDialog: false,
				ruleForm: {
					groupCode: "",
					groupId: "",
					groupName: "",
					groupNcCode: "",
					groupShortName: "",
					groupType: "",
					parentId: "",
					pricePlan: "",
					pricePlanName: "",
				},
				rules: {
					groupName: [{
						required: true,
						message: '请输入部门全称',
						trigger: 'blur'
					}, ],
					groupShortName: [{
						required: true,
						message: '请输入部门简称',
						trigger: 'blur'
					}, ],
					groupCode: [{
							required: true,
							message: '请输入部门编码',
							trigger: 'blur'
						},
						{
							pattern: /^[A-Z0-9]{1,5}$/,
							message: '请输入5位以内大写英文、数字',
							trigger: 'blur'
						},
					],
					profitCenterCode: [{
							required: true,
							message: '请输入SAP利润中心',
							trigger: 'blur'
						},
						{
							pattern: /^[A-Z0-9]*$/,
							message: '请输入大写英文、数字',
							trigger: 'blur'
						},
					],
					pricePlanName: [{
						required: true,
						message: '请配置价格方案',
						trigger: 'blur'
					}, ],

				},
				currentFrom: {}
			}
		},
		created() {

		},
		methods: {
			init(data, type) {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.ruleForm = {
						groupCode: "",
						groupId: "",
						groupName: "",
						profitCenterCode: "",
						groupShortName: "",
						groupType: "",
						parentId: "",
						pricePlan: "",
						pricePlanName: "",
					}
					this.currentFrom = ""
					if (data) {
						this.currentFrom = data
						this.currentFrom.currentName = data.groupName
					}
					// 2新增 1修改
					if (type == 1) {
						this.getRow()
					}
				})
			},
			//获取选择的价格方案列表
			getPriceList(val) {
				let idArr = []
				let nameArr = []
				val.forEach(item => {
					idArr.push(item.priceId)
					nameArr.push(item.priceName)
				});
				this.ruleForm.pricePlan = idArr.join(",")
				this.ruleForm.pricePlanName = nameArr.join(",")
			},
			// 展示价格方案
			showPriceScheme() {
				this.priceSchemeDialog = true;
				this.$nextTick(() => {
					this.$refs.priceScheme.init(this.ruleForm.pricePlan);
				});
			},
			// 保存
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
							if (!this.ruleForm.groupId) {
								this.addRow()
							} else {
								this.updateRow()
							}
						}).catch(() => {});
					} else {
						return false;
					}
				});
			},
			// 新增
			addRow() {
				let that = this;
				that.$request.post(
						"groupAdd",
						true, {
							groupCode: that.ruleForm.groupCode,
							groupName: that.ruleForm.groupName,
							profitCenterCode: that.ruleForm.profitCenterCode,
							groupShortName: that.ruleForm.groupShortName,
							groupType: that.ruleForm.groupType ? 1 : 0,
							parentId: that.currentFrom.groupId,
							pricePlan: that.ruleForm.pricePlan,
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$emit("getList")
						}
					})
			},
			// 修改
			updateRow() {
				let that = this;
				that.$request.post(
						"groupUpdate",
						false, {
							groupCode: that.ruleForm.groupCode,
							groupId: that.currentFrom.groupId,
							groupName: that.ruleForm.groupName,
							profitCenterCode: that.ruleForm.profitCenterCode,
							groupShortName: that.ruleForm.groupShortName,
							groupType: that.ruleForm.groupType ? 1 : 0,
							parentId: that.currentFrom.parentId,
							pricePlan: that.ruleForm.pricePlan,
						}
					)
					.then((res) => {
						if (res) {
							that.dialogVisible = false
							that.$message.success("保存成功！");
							that.$emit("getList")
						}
					})
			},
			// 查看
			getRow() {
				let that = this;
				that.$request.post(
						"groupInfo",
						true, {
							groupId: that.currentFrom.groupId,
						}
					)
					.then((res) => {
						if (res) {
							that.ruleForm = {
								groupCode: res.data.groupCode,
								groupId: res.data.groupId,
								groupName: res.data.groupName,
								profitCenterCode: res.data.profitCenterCode,
								groupShortName: res.data.groupShortName,
								groupType: res.data.groupType == 1 ? true : false,
								parentId: res.data.parentId,
								pricePlan: res.data.pricePlan,
								pricePlanName: res.data.priceName
							}
							that.currentFrom.currentName = res.data.parentName
						}
					})
			},

			// 取消
			cancle() {
				this.dialogVisible = false
				this.$refs['ruleForm'].resetFields();
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.width100 {
		width: 440px;
	}

	.form-text {
		color: #606266;
	}

	.w190 {
		width: 160px !important;
	}

	.w440 {
		width: 440px !important;
	}

	.line {
		&.el-divider--horizontal {
			margin: 8px 0 24px;
		}
	}

</style>
